import OpportunityCalendar from './calendar';

export default OpportunityCalendar;
